function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M312.679 282.356h35.657c9.847 0 17.828-7.982 17.828-17.828 0-29.539 23.947-53.485 53.485-53.485h178.285c29.539 0 53.485 23.947 53.485 53.485 0 9.847 7.982 17.828 17.828 17.828h35.657c9.847 0 17.828-7.982 17.828-17.828v-35.657c0-49.232-39.911-89.143-89.143-89.143h-249.6c-49.232 0-89.143 39.911-89.143 89.143v35.657c0 9.847 7.982 17.828 17.828 17.828v0zM651.422 612.208c0 14.769-11.949 26.719-26.719 26.719h-44.595c-9.847 0-17.828 7.982-17.828 17.828v62.423c0 14.769-11.949 26.719-26.719 26.719h-35.657c-14.769 0-26.767-11.949-26.767-26.719v-62.423c0-9.847-7.982-17.828-17.828-17.828h-44.547c-14.817 0-26.767-11.949-26.767-26.719v-35.657c0-14.769 11.949-26.767 26.767-26.767h44.547c9.847 0 17.828-7.982 17.828-17.828v-44.547c0-14.769 11.997-26.767 26.767-26.767h35.657c14.769 0 26.719 11.997 26.719 26.767v44.547c0 9.847 7.982 17.828 17.828 17.828h44.595c14.769 0 26.719 11.997 26.719 26.767v35.657zM794.051 318.013h-570.515c-49.232 0-89.143 39.911-89.143 89.143v374.4c0 49.232 39.911 89.143 89.143 89.143h570.515c49.232 0 89.143-39.911 89.143-89.143v-374.4c0-49.232-39.911-89.143-89.143-89.143v0z",
  "p-id": 4521
});

function SvgMedic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632295072568,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4520,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedic);
export default __webpack_public_path__ + "static/media/medic.376d803b.svg";
export { ForwardRef as ReactComponent };